import { CLASSES as u } from "../Types.js";
import { Attribute as g } from "../Attribute.js";
import { AttributeDefinitions as E } from "../AttributeDefinitions.js";
import { DockLocation as _ } from "../DockLocation.js";
import { DropInfo as m } from "../DropInfo.js";
import { Orientation as T } from "../Orientation.js";
import { Rect as b } from "../Rect.js";
import { BorderNode as R } from "./BorderNode.js";
import { Node as A } from "./Node.js";
import { RowNode as I } from "./RowNode.js";
import { TabNode as f } from "./TabNode.js";
import { adjustSelectedIndex as H } from "./Utils.js";
class o extends A {
  static TYPE = "tabset";
  /** @internal */
  static _fromJson(t, e) {
    const r = new o(e, t);
    if (t.children != null)
      for (const h of t.children) {
        const i = f._fromJson(h, e);
        r._addChild(i);
      }
    return r._children.length === 0 && r._setSelected(-1), t.maximized && t.maximized === !0 && e._setMaximizedTabset(r), t.active && t.active === !0 && e._setActiveTabset(r), r;
  }
  /** @internal */
  static _attributeDefinitions = o._createAttributeDefinitions();
  /** @internal */
  static _createAttributeDefinitions() {
    const t = new E();
    return t.add("type", o.TYPE, !0).setType(g.STRING).setFixed(), t.add("id", void 0).setType(g.STRING), t.add("weight", 100).setType(g.NUMBER), t.add("width", void 0).setType(g.NUMBER), t.add("height", void 0).setType(g.NUMBER), t.add("selected", 0).setType(g.NUMBER), t.add("name", void 0).setType(g.STRING), t.add("config", void 0).setType("any"), t.addInherited("enableDeleteWhenEmpty", "tabSetEnableDeleteWhenEmpty"), t.addInherited("enableDrop", "tabSetEnableDrop"), t.addInherited("enableDrag", "tabSetEnableDrag"), t.addInherited("enableDivide", "tabSetEnableDivide"), t.addInherited("enableMaximize", "tabSetEnableMaximize"), t.addInherited("showMaximize", "tabSetShowMaximize"), t.addInherited("enableClose", "tabSetEnableClose"), t.addInherited("classNameTabStrip", "tabSetClassNameTabStrip"), t.addInherited("classNameHeader", "tabSetClassNameHeader"), t.addInherited("enableTabStrip", "tabSetEnableTabStrip"), t.addInherited("borderInsets", "tabSetBorderInsets"), t.addInherited("marginInsets", "tabSetMarginInsets"), t.addInherited("minWidth", "tabSetMinWidth"), t.addInherited("minHeight", "tabSetMinHeight"), t.addInherited("headerHeight", "tabSetHeaderHeight"), t.addInherited("tabStripHeight", "tabSetTabStripHeight"), t.addInherited("tabLocation", "tabSetTabLocation"), t.addInherited("autoSelectTab", "tabSetAutoSelectTab").setType(g.BOOLEAN), t;
  }
  /** @internal */
  _contentRect;
  /** @internal */
  _tabHeaderRect;
  /** @internal */
  _calculatedTabBarHeight;
  /** @internal */
  _calculatedHeaderBarHeight;
  /** @internal */
  constructor(t, e) {
    super(t), o._attributeDefinitions.fromJson(e, this._attributes), t._addNode(this), this._calculatedTabBarHeight = 0, this._calculatedHeaderBarHeight = 0;
  }
  getName() {
    return this._getAttr("name");
  }
  getSelected() {
    const t = this._attributes.selected;
    return t !== void 0 ? t : -1;
  }
  getSelectedNode() {
    const t = this.getSelected();
    if (t !== -1)
      return this._children[t];
  }
  getWeight() {
    return this._getAttr("weight");
  }
  getWidth() {
    return this._getAttr("width");
  }
  getMinWidth() {
    return this._getAttr("minWidth");
  }
  getHeight() {
    return this._getAttr("height");
  }
  getMinHeight() {
    return this._getAttr("minHeight");
  }
  /** @internal */
  getMinSize(t) {
    return t === T.HORZ ? this.getMinWidth() : this.getMinHeight();
  }
  /**
     * Returns the config attribute that can be used to store node specific data that
     * WILL be saved to the json. The config attribute should be changed via the action Actions.updateNodeAttributes rather
     * than directly, for example:
     * this.state.model.doAction(
     *   FlexLayout.Actions.updateNodeAttributes(node.getId(), {config:myConfigObject}));
     */
  getConfig() {
    return this._attributes.config;
  }
  isMaximized() {
    return this._model.getMaximizedTabset() === this;
  }
  isActive() {
    return this._model.getActiveTabSet() === this;
  }
  isEnableDeleteWhenEmpty() {
    return this._getAttr("enableDeleteWhenEmpty");
  }
  isEnableDrop() {
    return this._getAttr("enableDrop");
  }
  isEnableDrag() {
    return this._getAttr("enableDrag");
  }
  isEnableDivide() {
    return this._getAttr("enableDivide");
  }
  isEnableMaximize() {
    return this._getAttr("enableMaximize");
  }
  isShowMaximize() {
    return this._getAttr("showMaximize");
  }
  isEnableClose() {
    return this._getAttr("enableClose");
  }
  canMaximize() {
    return this.isEnableMaximize() ? this.getModel().getMaximizedTabset() === this ? !0 : !(this.getParent() === this.getModel().getRoot() && this.getModel().getRoot().getChildren().length === 1) : !1;
  }
  isEnableTabStrip() {
    return this._getAttr("enableTabStrip");
  }
  isAutoSelectTab() {
    return this._getAttr("autoSelectTab");
  }
  getClassNameTabStrip() {
    return this._getAttr("classNameTabStrip");
  }
  getClassNameHeader() {
    return this._getAttr("classNameHeader");
  }
  /** @internal */
  calculateHeaderBarHeight(t) {
    const e = this._getAttr("headerHeight");
    e !== 0 ? this._calculatedHeaderBarHeight = e : this._calculatedHeaderBarHeight = t.headerBarSize;
  }
  /** @internal */
  calculateTabBarHeight(t) {
    const e = this._getAttr("tabStripHeight");
    e !== 0 ? this._calculatedTabBarHeight = e : this._calculatedTabBarHeight = t.tabBarSize;
  }
  getHeaderHeight() {
    return this._calculatedHeaderBarHeight;
  }
  getTabStripHeight() {
    return this._calculatedTabBarHeight;
  }
  getTabLocation() {
    return this._getAttr("tabLocation");
  }
  /** @internal */
  _setWeight(t) {
    this._attributes.weight = t;
  }
  /** @internal */
  _setSelected(t) {
    this._attributes.selected = t;
  }
  /** @internal */
  canDrop(t, e, r) {
    let h;
    if (t === this) {
      const i = _.CENTER, a = this._tabHeaderRect;
      h = new m(this, a, i, -1, u.FLEXLAYOUT__OUTLINE_RECT);
    } else if (this._contentRect.contains(e, r)) {
      let i = _.CENTER;
      this._model.getMaximizedTabset() === void 0 && (i = _.getLocation(this._contentRect, e, r));
      const a = i.getDockRect(this._rect);
      h = new m(this, a, i, -1, u.FLEXLAYOUT__OUTLINE_RECT);
    } else if (this._tabHeaderRect != null && this._tabHeaderRect.contains(e, r)) {
      let i, a, d;
      if (this._children.length === 0)
        i = this._tabHeaderRect.clone(), a = i.y + 3, d = i.height - 4, i.width = 2;
      else {
        let s = this._children[0];
        i = s.getTabRect(), a = i.y, d = i.height;
        let n = this._tabHeaderRect.x, c = 0;
        for (let l = 0; l < this._children.length; l++) {
          if (s = this._children[l], i = s.getTabRect(), c = i.x + i.width / 2, e >= n && e < c) {
            const p = _.CENTER, S = new b(i.x - 2, a, 3, d);
            h = new m(this, S, p, l, u.FLEXLAYOUT__OUTLINE_RECT);
            break;
          }
          n = c;
        }
      }
      if (h == null) {
        const s = _.CENTER, n = new b(i.getRight() - 2, a, 3, d);
        h = new m(this, n, s, this._children.length, u.FLEXLAYOUT__OUTLINE_RECT);
      }
    }
    if (t._canDockInto(t, h))
      return h;
  }
  /** @internal */
  _layout(t, e) {
    this.calculateHeaderBarHeight(e), this.calculateTabBarHeight(e), this.isMaximized() && (t = this._model.getRoot().getRect()), t = t.removeInsets(this._getAttr("marginInsets")), this._rect = t, t = t.removeInsets(this._getAttr("borderInsets"));
    const r = this.getName() !== void 0;
    let h = 0, i = 0;
    r && (h += this._calculatedHeaderBarHeight, i += this._calculatedHeaderBarHeight), this.isEnableTabStrip() && (this.getTabLocation() === "top" ? this._tabHeaderRect = new b(t.x, t.y + h, t.width, this._calculatedTabBarHeight) : this._tabHeaderRect = new b(t.x, t.y + t.height - this._calculatedTabBarHeight, t.width, this._calculatedTabBarHeight), i += this._calculatedTabBarHeight, this.getTabLocation() === "top" && (h += this._calculatedTabBarHeight)), this._contentRect = new b(t.x, t.y + h, t.width, t.height - i);
    for (let a = 0; a < this._children.length; a++) {
      const d = this._children[a];
      d._layout(this._contentRect, e), d._setVisible(a === this.getSelected());
    }
  }
  /** @internal */
  _delete() {
    this._parent._removeChild(this);
  }
  /** @internal */
  _remove(t) {
    const e = this._removeChild(t);
    this._model._tidy(), H(this, e);
  }
  /** @internal */
  drop(t, e, r, h) {
    const i = e;
    if (this === t)
      return;
    let a = t.getParent(), d = 0;
    if (a !== void 0 && (d = a._removeChild(t), a instanceof R && a.getSelected() === d ? a._setSelected(-1) : H(a, d)), t.getType() === f.TYPE && a === this && d < r && r > 0 && r--, i === _.CENTER) {
      let s = r;
      if (s === -1 && (s = this._children.length), t.getType() === f.TYPE)
        this._addChild(t, s), (h || h !== !1 && this.isAutoSelectTab()) && this._setSelected(s);
      else {
        for (let n = 0; n < t.getChildren().length; n++) {
          const c = t.getChildren()[n];
          this._addChild(c, s), s++;
        }
        this.getSelected() === -1 && this._children.length > 0 && this._setSelected(0);
      }
      this._model._setActiveTabset(this);
    } else {
      let s;
      if (t instanceof f) {
        const l = this._model._getOnCreateTabSet();
        s = new o(this._model, l ? l(t) : {}), s._addChild(t), a = s;
      } else
        s = t;
      const n = this._parent, c = n.getChildren().indexOf(this);
      if (n.getOrientation() === i._orientation)
        s._setWeight(this.getWeight() / 2), this._setWeight(this.getWeight() / 2), n._addChild(s, c + i._indexPlus);
      else {
        const l = new I(this._model, {});
        l._setWeight(this.getWeight()), l._addChild(this), this._setWeight(50), s._setWeight(50), l._addChild(s, i._indexPlus), n._removeChild(this), n._addChild(l, c);
      }
      this._model._setActiveTabset(s);
    }
    this._model._tidy();
  }
  toJson() {
    const t = {};
    return o._attributeDefinitions.toJson(t, this._attributes), t.children = this._children.map((e) => e.toJson()), this.isActive() && (t.active = !0), this.isMaximized() && (t.maximized = !0), t;
  }
  /** @internal */
  _updateAttrs(t) {
    o._attributeDefinitions.update(t, this._attributes);
  }
  /** @internal */
  _getAttributeDefinitions() {
    return o._attributeDefinitions;
  }
  /** @internal */
  _getPrefSize(t) {
    let e = this.getWidth();
    return t === T.VERT && (e = this.getHeight()), e;
  }
  /** @internal */
  static getAttributeDefinitions() {
    return o._attributeDefinitions;
  }
}
export {
  o as TabSetNode
};
//# sourceMappingURL=TabSetNode.js.map
